import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

export const DIALOG_TYPE = 'DELETE_TRANSACTION_RULE_DIALOG';

export const deleteTransactionRuleDialog = createAction(
  rootUiActions.createDialog.toString(),
  ({ ruleId, source, onDelete }: { ruleId: string; source: string; onDelete?: () => void }) =>
    rootUiTypes.mkRootUiData({
      id: 'delete-transaction-rule-dialog',
      type: DIALOG_TYPE,
      allowNesting: true,
      props: ImmutableMap({ ruleId, source, onDelete }),
    }),
);
